function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.5 15C3.36445 15 0 11.6356 0 7.5C0 3.36445 3.36445 0 7.5 0C11.6356 0 15 3.36445 15 7.5C15 11.6356 11.6356 15 7.5 15Z",
  fill: "#CCCCCC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.1786 10.7143C10.0415 10.7143 9.90441 10.662 9.79981 10.5573L4.44272 5.20019C4.23341 4.99088 4.23341 4.65191 4.44272 4.44271C4.65192 4.23351 4.99101 4.2334 5.2002 4.44271L10.5573 9.7998C10.7666 10.0091 10.7666 10.3481 10.5573 10.5573C10.4527 10.662 10.3157 10.7143 10.1786 10.7143Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.82141 10.7143C4.68431 10.7143 4.54732 10.662 4.44272 10.5573C4.23341 10.3481 4.23341 10.009 4.44272 9.79981L9.79981 4.44272C10.0091 4.23341 10.3481 4.23341 10.5573 4.44272C10.7665 4.65192 10.7666 4.99101 10.5573 5.2002L5.2002 10.5573C5.09561 10.662 4.95851 10.7143 4.82141 10.7143V10.7143Z",
  fill: "white"
});

const SvgCloseDelete = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCloseDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close_delete.45fc9f75.svg";
export { ForwardRef as ReactComponent };